import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-551f794e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav nav-sub-tabs mt-3" }
const _hoisted_2 = { class: "bg-black-body p-3 gameDetailForm" }
const _hoisted_3 = {
  key: 0,
  class: "text-white p-4"
}
const _hoisted_4 = {
  key: 0,
  class: "py-5 text-gray-text"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2 text-xl" }, "Release Game Version", -1))
const _hoisted_6 = { class: "py-5 text-gray-text" }
const _hoisted_7 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-40 my-2 md:my-0" }, "Platform Type", -1))
const _hoisted_9 = { class: "platform-icons grid grid-cols-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, "Browser-Based", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xr-icon-android text-success-check text-6xl" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, "Android", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-40 my-2 md:my-0" }, "Release Name*", -1))
const _hoisted_16 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-40 my-2 md:my-0" }, "Version*", -1))
const _hoisted_18 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm w-40 my-2 md:my-0" }, "Release Notes ", -1))
const _hoisted_20 = { class: "col-sm-12 col-md-9 col-lg-9 text-editor" }
const _hoisted_21 = { class: "form-group md:flex mb-3 items-center" }
const _hoisted_22 = { class: "text-white text-sm w-40 my-2 md:my-0" }
const _hoisted_23 = {
  for: "btnSingleFileUpload",
  class: "bg-black-header p-2 rounded-md px-4 text-white mb-2 cursor-pointer"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Choose File ")
const _hoisted_25 = {
  key: 0,
  class: "show-image-name mb-2"
}
const _hoisted_26 = { class: "text-white w-100 border-dotted row-img-upload p-2" }
const _hoisted_27 = { class: "m-0" }
const _hoisted_28 = { class: "mt-5" }
const _hoisted_29 = {
  key: 1,
  class: "text-white p-3"
}
const _hoisted_30 = { class: "overflow-auto" }
const _hoisted_31 = { class: "release-table table-auto text-gray-text px-5 m-0" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "App Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Release Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Version"),
    /*#__PURE__*/_createElementVNode("th", null, "Release Date")
  ])
], -1))
const _hoisted_33 = {
  key: 0,
  class: "mt-3 ml-2 text-gray-400 text-md"
}
const _hoisted_34 = {
  key: 2,
  class: "text-white p-3"
}
const _hoisted_35 = { class: "release-table table-auto text-gray-text px-5 m-0" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Username"),
    /*#__PURE__*/_createElementVNode("th", null, "Description"),
    /*#__PURE__*/_createElementVNode("th", null, "Date")
  ])
], -1))
const _hoisted_37 = {
  key: 0,
  class: "mt-3 ml-2 text-gray-400 text-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_editor = _resolveComponent("editor")!
  const _component_GamesDeleteReleaseModal = _resolveComponent("GamesDeleteReleaseModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("nav", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: _normalizeClass(["text-gray-text hover:text-white", _ctx.gameReleaseSelected == 'version'?'active':'inActive']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gameReleaseSelected = 'version'))
          }, "Current Version", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["text-gray-text hover:text-white", _ctx.gameReleaseSelected == 'releases'?'active':'inActive']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gameReleaseSelected = 'releases'))
          }, "Releases", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["text-gray-text hover:text-white", _ctx.gameReleaseSelected == 'feedback'?'active':'inActive']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gameReleaseSelected = 'feedback'))
          }, "Feedback", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.gameReleaseSelected == 'version')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", null, [
                (_ctx.listGameReleases === '' || _ctx.listGameReleases === [])
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, "You haven't released any version of this game yet."))
                  : _createCommentVNode("", true),
                _hoisted_5,
                _createElementVNode("p", _hoisted_6, "Input below the details of the present version of your game you would lile to release in the " + _toDisplayString(_ctx.testnetLabel) + " environment.", 1),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["drop-shadow-md text-center hover:border-gray-500 border-2 p-4 w-64 rounded-lg hover:bg-gray-800 transition-all duration-200 cursor-pointer text-sm", _ctx.selectedTab=='web'?'border-gray-700 bg-gray-700':'border-black-body']),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedTab = 'web'))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "fa-solid fa-window-maximize",
                          class: "text-6xl"
                        }),
                        _hoisted_10
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["drop-shadow-md text-center p-4 w-64 rounded-lg hover:bg-gray-800 hover:border-gray-500 border-2 transition-all duration-200 cursor-pointer ml-2 text-sm", _ctx.selectedTab=='android'?'border-gray-700 bg-gray-700':'border-black-body']),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedTab = 'android'))
                      }, _hoisted_13, 2)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control bg-input-field border-left-0 text-white",
                      placeholder: "Happy Gaming Studio LLC",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.gameRelease.ReleaseName) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.gameRelease.ReleaseName]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control bg-input-field border-left-0 text-white",
                      placeholder: "0.0.1",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.gameRelease.Version) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.gameRelease.Version]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_editor, {
                      modelValue: _ctx.gameRelease.ReleaseNotes,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.gameRelease.ReleaseNotes) = $event)),
                      "api-key": "9jnfs249imm7zrkjewyq0e956gpatuk8q7ibj42i1ip52gmu",
                      init: {
                  height: 400,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount',
                  ],
                  toolbar:
                    'undo redo | formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | removeformat | help',
                }
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, "Upload " + _toDisplayString(_ctx.selectedTab=='web'?' .rar /.zip File':'Android .apk File '), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_23, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-paperclip",
                        class: "text-blue-primary inline-block mr-2"
                      }),
                      _hoisted_24
                    ]),
                    _createElementVNode("input", {
                      id: "btnSingleFileUpload",
                      style: {"display":"none"},
                      ref: "fileInput",
                      type: "file",
                      onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
                      accept: ".rar, .zip, .apk"
                    }, null, 544),
                    (this.fileName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("p", _hoisted_27, _toDisplayString(this.fileName), 1),
                            _createVNode(_component_font_awesome_icon, {
                              icon: "fa-solid fa-times-circle",
                              class: "inline-block",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.removeFile()))
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-primary px-5", [this.fileName ? '' : 'opacity50']]),
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.updateRelease && _ctx.updateRelease(...args)))
                }, _toDisplayString(_ctx.isSaving), 3)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.gameReleaseSelected == 'releases')
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("table", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listGameReleases, (release) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: release.gameId
                      }, [
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(release.platform) + "  ", 1),
                          (release.platform === 'WebGL')
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: "fa-solid fa-display"
                              }))
                            : (release.platform === 'Android')
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 1,
                                  icon: "fa-brands fa-android"
                                }))
                              : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(release.releaseName), 1),
                        _createElementVNode("td", null, _toDisplayString(release.version), 1),
                        _createElementVNode("td", null, _toDisplayString(release.createdFormattedDate), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-trash",
                            class: "text-gray-text hover:text-gray-50 cursor-pointer",
                            onClick: _withModifiers(($event: any) => (_ctx.displayConfirmDeleteModal = true, _ctx.selectedRelease = release.version, _ctx.selectedPlatform = release.platform), ["prevent"])
                          }, null, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                (_ctx.listGameReleases.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, "No release yet"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.gameReleaseSelected == 'feedback')
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", null, [
                _createElementVNode("table", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedbackList, (feedback) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: feedback.feedbackId
                      }, [
                        _createElementVNode("td", null, _toDisplayString(feedback.username), 1),
                        _createElementVNode("td", null, _toDisplayString(feedback.message), 1),
                        _createElementVNode("td", null, _toDisplayString(feedback.timeCreated) + " " + _toDisplayString(feedback.dateCreated), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                (_ctx.feedbackList.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, "No feedback available yet"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_GamesDeleteReleaseModal, {
      displayConfirmDeleteModal: _ctx.displayConfirmDeleteModal,
      onCloseConfirmDeleteModal: _cache[11] || (_cache[11] = ($event: any) => (_ctx.displayConfirmDeleteModal = false)),
      onDeleteReleaseModalSuccess: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteReleaseSucess())),
      version: _ctx.selectedRelease,
      platform: _ctx.selectedPlatform
    }, null, 8, ["displayConfirmDeleteModal", "version", "platform"])
  ], 64))
}